module.exports = __webpack_public_path__ + "static/media/double-arrow-down.d9455c07.svg";